import {
  ChakraFlex,
  ChakraVStack,
  FAIconName,
  FireflyButton,
  ModalV2,
  ReviewPatientCard,
  Text,
} from '@equip.health/ui';

import { unixTimestampToDate } from '~/lib/util/date.util';

interface ConfirmPatientProfileMatchModalProps {
  id: string;
  isOpen: boolean;
  onCancel: () => void;
  onUseProfile: () => void;
  selectedProfile: PatientMatch;
}

const modalArgs = {
  bodyStyle: {
    overflow: 'visible',
    padding: '18px 0',
  },
  footerStyle: {
    padding: '0px',
  },
  title: 'Confirm patient profile match',
  titleStyle: {
    flex: '1 0 0',
    padding: '0px',
  },
};
const ConfirmPatientProfileMatchModal = ({
  id,
  isOpen,
  onCancel,
  onUseProfile,
  selectedProfile,
}: ConfirmPatientProfileMatchModalProps) => {
  const TOP_LEVEL_ID = `${id}__confirm-patient-profile-modal`;
  const subTitle = 'This inquiry will be added to the following patient chart.';
  return (
    <ModalV2
      footerContent={
        <ChakraFlex justifyContent="space-between" width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}__cancel`}
            leftIcon={FAIconName.chevronLeftRegular}
            onClick={onCancel}
            variant="secondary"
          >
            Back
          </FireflyButton>
          <FireflyButton
            id={`${TOP_LEVEL_ID}__use-profile`}
            leftIcon={FAIconName.checkRegular}
            onClick={onUseProfile}
            variant="primary"
          >
            Use this profile
          </FireflyButton>
        </ChakraFlex>
      }
      size="lg"
      {...modalArgs}
      id={`${TOP_LEVEL_ID}__modal`}
      isOpen={isOpen}
      onClose={onCancel}
    >
      <ChakraVStack gap="18px" width="100%">
        <Text alignSelf="start" id={`${id}-subtitle`} variant="body">
          {subTitle}
        </Text>
        <ReviewPatientCard
          // TODO: Active inquiry per patient match will be supported once PT-654 is done, see props starting
          // with activeInquiry.
          birthDate={
            selectedProfile.dateOfBirth
              ? new Date(selectedProfile.dateOfBirth)
              : null
          }
          chosenName={selectedProfile.chosenName ?? ''}
          createdDate={unixTimestampToDate(selectedProfile.createdAt)}
          firstName={selectedProfile.firstName ?? ''}
          id={`${TOP_LEVEL_ID}__review-patient-card__${selectedProfile.externalId}`}
          key={selectedProfile.externalId}
          lastName={selectedProfile.lastName ?? ''}
          matchedFields={[]} // no matched fields highlighting in this view needed as this is confirmation
          phoneNumber={selectedProfile.patientPhoneNumber ?? ''}
        />
      </ChakraVStack>
    </ModalV2>
  );
};

export default ConfirmPatientProfileMatchModal;
